import { Component, OnInit} from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { RegistrationService } from '../../services/registration.service';
import { ListManagerService } from '../../services/list-manager.service';
import { EnrollmentService } from '../../services/enrollment.service';
import _ from 'lodash';
import { PhoneService } from 'src/app/services/phone.service';
import { VariablesService } from 'src/app/services/variables.service';
@Component({
    templateUrl: './attendee.component.html',
    standalone: false
})
export class AttendeeComponent implements OnInit {
  isSubmitting = false;
  isError = false;
  attendee;
  prefixList;
  suffixList;
  workPhone;
  homePhone;
  mobilePhone;
  workAddress;
  homeAddress;
  emailAddress;
  adminContact;
  adminPhone;
  emerContact;
  emerContactMainPhone;
  emerContactAltPhone;
  DisabilityType;
  mealList;
  personalConsiderationsList;
  $mtcverifyEmailAddress;
  $mtcMailToAddress;
  mtcMailToAddress;
  isRegComplete;
  enrollment;
  answer;
  isFormCompleted = false;
  triedSubmit = false;
  departmentName;
  clickedCountry;
  benefitLevel;
  benefits = false;
  advisoryBoardList = [
    {display: "Not Applicable"},
    {display:"Enterprise Council"},
    {display:"Fee Centric Advisory Council"},
    {display: "HNW Planing Council"},
    {display:"National Advisory Board"},
    {display:"NOEC Staff Council"},
    {display:"NextGen Council"},
    {display:"Teams Council"},
    {display:"Women's Advisory Board"},
  ];
  advisoryBoard;
  neurodiversity;
  foodAllergiesList = [
    { code: "Dairy", name: "Dairy" },
    { code: "Eggs", name: "Eggs" },
    { code: "Peanuts", name: "Peanuts" },
    { code: "Tree Nuts", name: "Tree Nuts (almonds/cashews/walnuts)" },
    { code: "Fish", name: "Fish (bass/cod/flounder)" },
    { code: "Shellfish", name: "Shellfish (crab/lobster/shrimp)" },
    { code: "Soy", name: "Soy" },
    { code: "Wheat", name: "Wheat" },
    { code: "Other", name: "Other" }
  ];
  langinterp;
  donation;
  wealthManagementFirm;
  wealthManagementFirmList = [
    { value: "Osaic Wealth", display: "Osaic Wealth" },
    { value: "Osaic Institutions", display: "Osaic Institutions" },
    { value: "Osaic Advisory Services", display: "Osaic Advisory Services" },

  ]
  wealthManagementLevelList = [
    { value: "Oasis", display: "Oasis" },
    { value: "Ovation", display: "Ovation" },
    { value: "Odyssey", display: "Odyssey" },
    { value: "Optimum", display: "Optimum" },

  ];
  yesNo = [
    { value: "Yes", display: "Yes" },
    { value: "No", display: "No" },
  ];
  wealthManagementLevel;
  CFP;
  crdNumber;
  fieldManager;
  OSJ;
  disableAdvisoryBoard = false;
  childEventClicked(data) {
    this.clickedCountry = data;
  }


  constructor(
    private navigationService: NavigationService,
    private registrationService: RegistrationService,
    private listService: ListManagerService,
    private enrollmentService: EnrollmentService,
    private phoneService: PhoneService,
    private variablesService: VariablesService
  ) {

    this.enrollment = this.registrationService.getEnrollment({});
    this.isRegComplete = this.registrationService.isRegistrationComplete();
    // this.enrollment.HotelNeeded = "false"; 

    this.attendee = this.registrationService.getAttendee({});
    console.log(this.attendee);
    this.workPhone = this.registrationService.getPhone(this.attendee, "WORK", {});
    this.homePhone = this.registrationService.getPhone(this.attendee, "HOME", {});
    this.mobilePhone = this.registrationService.getPhone(this.attendee, "MOBILE", {});
    this.workAddress = this.registrationService.getAddress(this.attendee, "WORK", {});
    this.homeAddress = this.registrationService.getAddress(this.attendee, "HOME", {});
    this.emailAddress = this.registrationService.getEmail(this.attendee, "BUSINESS", {});

    this.adminContact = this.registrationService.getAdminContact({});
    this.adminPhone = this.adminContact.AdminContactPhone[0];
    this.emerContactMainPhone = this.registrationService.getEmergencyContactPhone(this.attendee, "DTPHONE", {});
    this.emerContactAltPhone = this.registrationService.getEmergencyContactPhone(this.attendee, "ALTPHONE", {});
    this.DisabilityType = this.registrationService.getDisabilities(this.attendee, "");
    //pax variables
    this.departmentName = registrationService.getVariable(this.attendee,variablesService.VARIABLE.DEPARTMENT_NAME.ID,{});
    this.advisoryBoard = registrationService.getVariable(this.attendee,variablesService.VARIABLE.ADVISORY_BOARD.ID,{});
    this.neurodiversity = registrationService.getVariable(this.attendee,variablesService.VARIABLE.NEURODIVERSITY.ID,{});
    this.langinterp = registrationService.getVariable(this.attendee,variablesService.VARIABLE.LANG_INTERP.ID,{});
    this.donation = registrationService.getVariable(this.attendee,variablesService.VARIABLE.DONATION.ID,{});
    this.wealthManagementFirm = registrationService.getVariable(this.attendee,variablesService.VARIABLE.WEALTH_MANAGEMENT_FIRM.ID,{});
    this.wealthManagementLevel = registrationService.getVariable(this.attendee,variablesService.VARIABLE.WEALTH_MANAGEMENT_FIRM_LEVEL.ID,{});
    this.CFP = registrationService.getVariable(this.attendee,variablesService.VARIABLE.CFP.ID,{});
    this.crdNumber = registrationService.getVariable(this.attendee,variablesService.VARIABLE.varCRDNumber.ID,{});
    this.fieldManager = registrationService.getVariable(this.attendee,variablesService.VARIABLE.FIELD_MANAGER.ID,{});
    this.OSJ = registrationService.getVariable(this.attendee,variablesService.VARIABLE.OSJ.ID,{});
    this.benefitLevel = registrationService.getVariable(this.attendee,variablesService.VARIABLE.varBenefitLevel.ID,{});
    if ( this.benefitLevel.Value ) {
      this.wealthManagementLevel.Value = this.benefitLevel.Value;
      this.benefits = true;
    }
    if(this.workAddress.CountryISOCode === "" || this.workAddress.CountryISOCode === " " || this.workAddress.CountryISOCode === undefined){
      this.workAddress.CountryISOCode = "US";
    }

    if(this.homeAddress.CountryISOCode === "" || this.homeAddress.CountryISOCode === " " || this.homeAddress.CountryISOCode === undefined){
      this.homeAddress.CountryISOCode = "US";
    }




    if(this.attendee.ResidenceCountryISOCode && this.workAddress.CountryISOCode){
      if(this.attendee.ResidenceCountryISOCode == this.workAddress.CountryISOCode){
        this.attendee.$mtcvarCountryOfRes = 'Yes';
      }else{
        this.attendee.$mtcvarCountryOfRes = 'No';
      }
    }

    this.listService.getCommonPrefixList().then(list => {
      this.prefixList = list;
    });
    this.listService.getSuffixList().then(list => {
      this.suffixList = list;
    });
    this.listService.getMealPreferenceList().then(list => {
      this.mealList = list;
    });
    this.listService.getDisabilityList().then(list => {
      this.personalConsiderationsList = list;
      this.personalConsiderationsList.forEach(disability => {
        if(disability.name == "Hearing Impaired"){
          disability.name = "Deaf/Hard of Hearing"
        }
      });
    });
    this.mtcMailToAddress = "WORK";

    this.detectMailTo();
    this.setMailTo();
    if(!this.attendee.$mtcAllergens) {
      this.attendee.$mtcAllergens = [];
    }

  }

  ngOnInit(): void { }

  includes(arr, val){
    return _.includes(arr, val);
  }
  allergyUpdate(allergy){
    let justadded = false;

    if (!_.includes(this.attendee.$mtcAllergens, allergy.code)) {
      this.attendee.$mtcAllergens.push(allergy.code);
      justadded = true;
    }
    if (justadded === false && _.includes(this.attendee.$mtcAllergens, allergy.code)) {
      var index = this.attendee.$mtcAllergens.indexOf(allergy.code);
      if (index !== -1) {
        this.attendee.$mtcAllergens.splice(index, 1);
      }
    }
  }
  considerationUpdate(consideration) {
    let justadded = false;

    if (!_.includes(this.attendee.DisabilityType, consideration.code)) {
      this.attendee.DisabilityType.push(consideration.code);
      justadded = true;
    }
    if (justadded === false && _.includes(this.attendee.DisabilityType, consideration.code)) {
      var index = this.attendee.DisabilityType.indexOf(consideration.code);
      if (index !== -1) {
        this.attendee.DisabilityType.splice(index, 1);
      }
    }
  }

  FieldsChange(values:any) {
    if (values.checked) {
      this.homeAddress.AddressLine1 = this.workAddress.AddressLine1;
      this.homeAddress.AddressLine2 = this.workAddress.AddressLine2;
      this.homeAddress.Zip = this.workAddress.Zip;
      this.homeAddress.City = this.workAddress.City;
      this.homeAddress.StateProvince = this.workAddress.StateProvince;
      this.homeAddress.CountryISOCode = this.workAddress.CountryISOCode;
    } else {
      this.homeAddress.AddressLine1 = "";
      this.homeAddress.AddressLine2 = "";
      this.homeAddress.Zip = "";
      this.homeAddress.City = "";
      this.homeAddress.StateProvince = "";
      this.homeAddress.CountryISOCode = "";
    }
  }
  cleanAdminContact() {
    if (!this.enrollment.$mtcHasAdminContact) {
        this.adminContact.AdminContactName = undefined;
        this.adminContact.AdminContactEmailAddress = undefined;
        this.adminContact.AdminContactPhone = undefined;
    }
  }
  cleanConsiderations() {
    if (!(this.attendee.DietaryNeed === "FOODALLE") && !(this.attendee.DietaryNeed === "OTHER")) {
      this.attendee.DietaryConsiderations = undefined;
    }
    if (this.attendee.DisabilityType) {

      if (!_.includes(this.attendee.DisabilityType, 'OTHER')) {
        this.attendee.PersonalConsiderations = undefined;
      }
    }
    // if (!this.attendee.$mtcHasConsiderations) {
    //     this.attendee.DietaryNeed = undefined;
    //     this.attendee.DietaryConsiderations = undefined;
    //     this.attendee.DisabilityType = undefined;
    //     this.attendee.PersonalConsiderations = undefined;
    // } else if (this.attendee.DietaryNeed === undefined && this.attendee.DisabilityType.length === 0) {
    //   this.attendee.$mtcHasConsiderations = false;
    // }
  }


  detectMailTo(){
    if(this.attendee){
      this.attendee.Address.forEach(add => {
        if(add.MailTo){
          this.mtcMailToAddress = add.AddressType;
        }
      });
    }

  }

  setMailTo() {
    if(this.attendee){
      this.attendee.Address.forEach(add => {
        if(add.AddressType === this.mtcMailToAddress){
          add.MailTo = true;
        }else{
          add.MailTo = false;
        }
      });
    }
    this.phoneService.triggeredChange();
  }


  forward(form) {
    this.isSubmitting = true;
    this.isFormCompleted = true;
    this.triedSubmit = true;

    console.log(form);
    if (form.valid) {
      this.cleanAdminContact();
      //this.cleanConsiderations();
      this.navigationService.forward();
    } else {
      this.isError = true;
      this.isSubmitting = false;

    }
  }

  back() {
    this.navigationService.back();
  }
}
